import { render, staticRenderFns } from "./FormExcavatorWorkPlatform.vue?vue&type=template&id=77a92ed2&scoped=true"
import script from "./FormExcavatorWorkPlatform.vue?vue&type=script&lang=js"
export * from "./FormExcavatorWorkPlatform.vue?vue&type=script&lang=js"
import style0 from "./FormExcavatorWorkPlatform.vue?vue&type=style&index=0&id=77a92ed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a92ed2",
  null
  
)

export default component.exports